<template>
  <div>
    <div id="content" class="content" style="margin-left:0px;">
      <h1 class="page-header" style="text-align:left">
        采购订单管理
        <small>/&nbsp;采购单列表</small>
      </h1>

      <div
        id="page-container"
        class="in page-sidebar-fixed page-header-fixed"
        style="padding-top:0px;"
      >
        <!-- begin #content -->
        <div
          id="content"
          class="content"
          style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
        >
          <!-- begin breadcrumb -->

          <div class="row">
            <!-- begin col-10 -->
            <div class="col-lg-12">
              <!-- begin panel -->
              <div class="panel panel-inverse">
                <!-- begin panel-heading -->
                <div class="panel-heading">
                  <div class="panel-heading-btn">
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-default"
                      data-click="panel-expand"
                    >
                      <i class="fa fa-expand"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-success"
                      data-click="panel-reload"
                    >
                      <i class="fa fa-redo"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-warning"
                      data-click="panel-collapse"
                    >
                      <i class="fa fa-minus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-danger"
                      data-click="panel-remove"
                    >
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                  <h4 class="panel-title panelTitle">采购单列表</h4>
                </div>
                <!-- end panel-heading -->
                <!-- begin panel-body -->
                <div class="panel-body">
                  <form style="margin-top:16px;">
                    <fieldset>
                      <div class="form-group row m-b-15">
                        <label class="col-md-1 col-form-label">采购单号</label>
                        <div class="col-md-2">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="采购单号"
                            v-model="orderNo"
                          >
                        </div>
                        <label class="col-md-1 col-form-label">服务商名称</label>
                        <div class="col-md-2">
                          <el-select
                            v-model="recomId"
                            style="width:100%;font-size:12px;"
                            clearable
                            filterable
                            placeholder="服务商名称"
                          >
                            <el-option
                              v-for="item in recomList"
                              :key="item.recomId"
                              :label="item.recomName"
                              :value="item.recomId"
                            ></el-option>
                          </el-select>
                        </div>
                        <label class="col-md-1 col-form-label">下单时间</label>
                        <div class="col-md-3">
                          <el-date-picker
                            style="width:100%;height:34px;"
                            v-model="TimeValue"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="ChangePicker"
                          ></el-date-picker>
                        </div>
                        <div class="col-md-2"></div>
                        <label class="col-md-1 col-form-label LineSpacing">采购单状态</label>
                        <div class="col-md-2 LineSpacing">
                          <el-select
                            v-model="orderStatus"
                            clearable
                            placeholder="请选择"
                            style="width:100%;font-size:12px;"
                          >
                            <el-option
                              v-for="item in orderStatusLists"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </div>

                        <div class="col-md-1 LineSpacing">
                          <a class="btn btn-primary ButtonColor m-r-5" @click="SearchClick()">查询</a>
                        </div>
                        <div class="col-md-11"></div>
                        <div class="col-md-1">
                          <a class="btn btn-primary ButtonColor m-r-5" @click="ExportClick()">导出</a>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                  <el-table :data="purchaseList" border style="width: 100%">
                    <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="orderNo" label="订单编号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="recomTypeName" label="客户类型" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="recomName" label="客户名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="orderCount" label="下单数量" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="orderPrice" label="下单金额(元)" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="inputTime" label="下单时间" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="orderStatusName" label="订单状态" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="支付凭证" align="center" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <img :src="scope.row.fileUrl" alt="" v-if="scope.row.fileUrl" @click="EnlargeImg(scope.row)" class="LogoImg">
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                      <template slot-scope="scope">
                        <el-button
                          class="btn btn-primary btn-sm ButtonColor"
                          size="small"
                          @click="DetailClick(scope.row)"
                          >采购单详情
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="PaginationStyle">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="pageindex"
                      :page-sizes="[10,20,50,100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      background
                      :total="totalCount"
                    ></el-pagination>
                  </div>
                </div>
                <!-- end panel-body -->
              </div>
              <!-- end panel -->
            </div>
            <!-- end col-10 -->
          </div>
          <!-- end row -->
        </div>
        <!-- end #content -->
      </div>
      <el-dialog title :visible.sync="outerVisible" width="500px">
        <img :src="CurrentSelection.fileUrl" style="width:400px;">
      </el-dialog>
    </div>
  </div>
  
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "ContractReviewList",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      CurrentSelection:'',
      purchaseList:[],
      recomId:"",
      TimeValue: "",
      recomList: [],
      orderStatus:"",
      orderStatusList:[0,1,2],
      orderStatusLists: [
        {
          label: "待审核",
          value: "1"
        },
        {
          label: "同意审核",
          value: "2"
        },
        {
          label: "拒绝审核",
          value: "0"
        }
      ],
      director:0,
      orderNo:'',
    };
  },
  mounted: function() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initdata();
    this.getRecomList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    DetailClick(row){
      this.$router.push({ 
        path: "/purchaseorderdetail",
        query:{
          orderNo: row.orderNo,
          checkId: 3
        } 
      });
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    initdata() {
      let that = this;
       if(that.orderStatus != null && that.orderStatus != '' &&  that.orderStatus != 'undefined'){
        that.orderStatusList = that.orderStatus
      }
      const options = {
        url: "distribution/B2cTobOrderController/queryOrderPages",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          orderNo: that.orderNo,
          orderStatusList:  that.orderStatusList,
          recomId: that.recomId,
          startInputTime: that.startTime,
          endInputTime: that.endTime,
          current: that.pageindex,
          size: that.pageSize,
          director:that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.purchaseList = response.data.data.records;
          that.totalCount = response.data.data.total;
          for (var i in response.data.data.records) {
            response.data.data.records[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            if (response.data.data.records[i].orderStatus == 0) {
              response.data.data.records[i].orderStatusName = "审核拒绝";
            }else if(response.data.data.records[i].orderStatus == 1){
              response.data.data.records[i].orderStatusName = "待审核";
            }else if(response.data.data.records[i].orderStatus == 2){
              response.data.data.records[i].orderStatusName = "审核通过";
            }
            if (response.data.data.records[i].recomType == 2) {
              response.data.data.records[i].recomTypeName = "服务商";
            }else if (response.data.data.records[i].recomType == 1) {
              response.data.data.records[i].recomTypeName = "分销商";
            }
          }
          that.orderStatusList = [0,1,2];
        } else {
          http.handleHttpError(error, that);
        }
      })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 获取服务商列表
    getRecomList() {
      let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.recomList = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    EnlargeImg(row) {
      this.outerVisible = true;
      this.CurrentSelection = row;
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    ChangeDate(){
      this.ruleForm.depositTime = this.FormatAllDate(this.ruleForm.depositTime);
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
     //   采购单列表导出
/**/
 ExportClick() {
      let that = this;
       if(that.orderStatus != null && that.orderStatus != '' &&  that.orderStatus != 'undefined'){
        that.orderStatusList = that.orderStatus
      }
      const options = {
        url: "distribution/B2cTobOrderController/orderExport",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          orderNo: that.orderNo,
          orderStatusList:that.orderStatusList,
          recomId: that.recomId,
          startInputTime: that.startTime,
          endInputTime: that.endTime,
          current: that.pageindex,
          size: that.pageSize,
          director:that.director
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
          } else {
            that.ExportClickSecond();
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    ExportClickSecond() {
      let   that  = this
       if(that.orderStatus != null && that.orderStatus != '' &&  that.orderStatus != 'undefined'){
        that.orderStatusList = that.orderStatus
      }
      const options = {
        url: "distribution/B2cTobOrderController/orderExport",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
         orderNo: that.orderNo,
          orderStatusList: that.orderStatusList,
          recomId: that.recomId,
          startInputTime: that.startTime,
          endInputTime: that.endTime,
          current: that.pageindex,
          size: that.pageSize,
          director:that.director
        }),
        responseType: "blob"
      };
      axios(options)
        .then(function(response) {
          var filename = "采购单列表" + new Date().getTime();
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth{
  width:202px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px dashed #8c939d;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.LogoImg {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/topList.vue